import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { executeControlGroup } from '../Api'

export default generateApiAction({
  baseType: Types.CTRL_GROUPS.EXECUTE,
  api: executeControlGroup,
  responseType: RESPONSETYPE.ID
})



// WEBPACK FOOTER //
// ./src/actions/controlGroups/ExecuteAction.js